import React, { useEffect, useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';

//components 
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Badge from "beaktShared/components/Badge/Badge.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

//services
import { formateDate } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import SeletorTipoContrato from "./SeletorTipoContrato.js";
import { getContratosAVencer, TIPOS_CONTRATO_DASHBOARD } from "./DashboardContratosService.js";
import { TIPO_CONTRATO } from "beaktMatriz/views/Credenciamento/Steps/ContratoEstabelecimentoService.js";

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);


export default function VisualizarTodosContratosVencer({ closemodal, showmodal, tipoContrato = TIPO_CONTRATO.RENOVACAO }) {
  // BKT-1512: abre no tipo escolhido no card do dashboard e permite alternar
  const [tipo, setTipo] = React.useState(tipoContrato);
  const tipoLabel = (TIPOS_CONTRATO_DASHBOARD.find(x => x.value === tipo) || TIPOS_CONTRATO_DASHBOARD[0]).label;
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const [erro, setErro] = React.useState("");

  const [dadosContratosVencer, setdadosContratosVencer] = React.useState([]);
  const [loadingContratosVencer, setloadingContratosVencer] = React.useState([]);
  const [dataCSV,setdataCSV] = React.useState([]);  

  useEffect(() => {
    if (!showmodal)
      return;
    let ativo = true;
    setloadingContratosVencer(true);
    getContratosAVencer(session.franquiaId, 0, tipo).then(result => {
      if (!ativo)
        return;
      setloadingContratosVencer(false);
      setdadosContratosVencer(result.data);
      setErro(result.ok ? "" : (result.message || t('dashboard.contracts_load_error')));

      //dados para CSV
      let dtCsv = [];
      result.data.forEach(item => {
        var obj ={
          tipoContrato: t(tipoLabel),
          estabelecimento : item.estabelecimento,
          dataValidade :formateDate(item.dataValidade),
          diasParaVencimento : item.diasParaVencimento
        }
        dtCsv.push(obj);
      })

      setdataCSV(dtCsv);
    });
    return () => { ativo = false; };
  }, [showmodal, tipo, tipoLabel, session.franquiaId, t]);

  const columnsProps = [
    {
      Header: t('label.establishment'),
      accessor: "estabelecimento",
    },
    {
      Header: t('dashboard.contract_validity'),
      accessor: "dataValidade",
      Cell: (props) => <div> {formateDate(props.value)} </div>

    },
    {
      Header: t('dashboard.days_to_expiration'),
      accessor: "diasParaVencimento",
      Cell: (props) => <div> <Badge color="warning">{(props.value)}</Badge></div>
    },
  ]
  let columns = [...columnsProps];

  const handleCloseModalContratosAVencer = () => {
    closemodal(false);
  }

  // *******************************************************************************
  // ********************************** CABEÇALHO CSV **********************************
  // *******************************************************************************

  const columnsCSV = [
    { displayName: t('dashboard.contract_type'), id: "tipoContrato" },
    { displayName: "Estabelecimento", id: "estabelecimento" },
    { displayName: "Validade Contrato", id: "dataValidade" },
    { displayName: "Dias p/ vencimento", id: "diasParaVencimento" }
  ];

  return (
    <div>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + ' ' + classes.modalLarge
        }}
        fullWidth
        maxWidth="lg"
        open={showmodal}
        keepMounted
        onClose={() => handleCloseModalContratosAVencer()}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
          style={{ background: '#5c4477' }}
        >
          <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('dashboard.all_contracts_to_expire') + " — " + t(tipoLabel)}</h4>
        </DialogTitle>
        <DialogContent id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>

                <div style={{ float: 'left' }}>
                  <SeletorTipoContrato value={tipo} onChange={setTipo} disabled={loadingContratosVencer === true} />
                </div>
                {dataCSV.length > 0 &&

                  <div>
                    <div style={{ float: 'right' }}>
                      <CsvDownloader
                        filename={"ContratosAVencer_" + (tipo === TIPO_CONTRATO.GERAL ? "Geral" : "Renovacao")}
                        columns={columnsCSV}
                        datas={dataCSV}
                        separator={";"}>
                        <Button round color="default" size="sm" >CSV</Button>
                      </CsvDownloader>
                    </div><div style={{ clear: 'both' }}></div>
                  </div>
                }
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                {erro && <SnackbarContent color="danger" message={erro} />}
                <ReactTable
                  loading={loadingContratosVencer}
                  data={dadosContratosVencer}
                  columns={columns}
                  filterable
                  // defaultFilterMethod={noCaseSensitive}
                  defaultPageSize={10}
                  minRows={5}
                  showPaginationBottom={true}
                  className="-striped -highlight"
                  previousText='Anterior'
                  nextText='Próximo'
                  loadingText='Carregando...'
                  noDataText='Nenhum registro encontrado!'
                  pageText='Página'
                  ofText='de'
                  rowsText='linhas'
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </DialogContent>
      </Dialog>

    </div>
  );
}
